import React, { Component } from 'react';
import ProductTable from './productTable/ProductTable';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import dayjs from 'dayjs';

// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from "@material-ui/pickers";
//import Converter from "number-to-words";

class Products extends React.Component {
  constructor(props) {
    super(props);

    //  this.state.products = [];
    this.state = {};
    this.state.filterText = '';
    this.state.products = [];
    this.state.total = {
      gstTotal: 0,
      subTotal: 0,
      grandTotal: 0,
      freightCharge: 0,
      grandTotalAmount: 0,

      // inWords: "",
      terms: '',
      deliverDate: dayjs().format('YYYY-MM-DD'),
      installationDate: dayjs().format('YYYY-MM-DD'),
      vendorGstNo: '',

      deliverAddress: '',
      decathlonContactPerson: '',
      decathlonGst: '',
      poNo: '#123456',
    };
  }
  handleUserInput(filterText) {
    this.setState({ filterText: filterText });
  }
  handleRowDel(id) {
    //let index = this.state.products.indexOf(product);
    let newProd = this.state.products.filter((row) => row.id !== id);
    //this.state.products.splice(index, 1);
    this.setState((state) => {
      state.products = newProd;
      return state;
    });
  }

  handleAddEvent(evt) {
    let some = this.state.products;

    let slno = this.state.products.length + 1;
    var id = (+new Date() + Math.floor(Math.random() * 999999)).toString(36);

    let product = {
      id: id,
      slno: '',
      description: '',
      unit: '',
      qty: 0,
      rate: 0,
      amount: 0,
      gst: 0,
      gstAmount: 0,
      totalAmount: 0,
    };
    some.push(product);
    some.map((ins, index) => {
      some[index]['slno'] = index + 1;
    });

    //this.state.products.push(product);
    //this.setState(this.state.products);
    this.setState({ products: some });
  }

  handleProductTable(evt) {
    var item = {
      id: evt.target.id,
      name: evt.target.name,
      value: evt.target.value,
    };
    var products = this.state.products.slice();
    let gst_total = 0;
    let subtotal = 0;
    let grandtotal = 0;

    var newProducts = products.map(function (product) {
      let temp = 0;
      let temp1 = 0;
      let temp2 = 0;
      let temp3 = 0;
      for (var key in product) {
        if (key == item.name && product.id == item.id) {
          product[key] = item.value;

          if (key == 'qty' || key == 'rate' || key == 'gst') {
            let qty = product.qty;
            let rate = product.rate;
            let amount = rate * qty;
            let gst = product.gst;
            let gstAmount = (amount * gst) / 100;
            let totalAmount = amount + gstAmount;

            product['amount'] = amount;
            product['gstAmount'] = gstAmount;
            product['gst'] = gst;
            product['totalAmount'] = totalAmount;
          }
        }
        temp = product['gstAmount'];
        temp1 = product['amount'];
        temp2 = product['totalAmount'];
      }

      gst_total = gst_total + temp;
      subtotal = subtotal + temp1;
      grandtotal = grandtotal + temp2;
      temp3 = grandtotal;

      return product;
    });
    //let wordTo = Converter.toWords(this.state.total.grandTotal);

    //this.setState({ products: newProducts });
    let updateForm = { ...this.state.total };

    updateForm['gstTotal'] = gst_total;
    updateForm['subTotal'] = subtotal;
    updateForm['grandTotal'] = grandtotal;

    updateForm['grandTotalAmount'] = grandtotal;

    //updateForm["grandTotal"] = updateForm["grandTotal"] + temp;

    this.setState({
      total: updateForm,
    });

    //
  }

  handleFreightChange = (event) => {
    let updateForm = { ...this.state.total };

    updateForm['freightCharge'] = event.target.value;

    let sumOfGrand = this.state.total.grandTotalAmount;

    let addFreight = updateForm['freightCharge'];

    if (addFreight >= 0 && addFreight != '' && addFreight != null) {
      updateForm['grandTotal'] =
        parseFloat(sumOfGrand) + parseFloat(addFreight);

      this.setState({
        total: updateForm,
      });
    } else {
      updateForm['grandTotal'] = parseFloat(sumOfGrand);

      this.setState({
        total: updateForm,
      });
    }
  };

  handleTermChange = (event) => {
    let updateForm = { ...this.state.total };
    updateForm['terms'] = event.target.value;
    this.setState({
      total: updateForm,
    });
  };
  //---------------------------------------------------------------------------//
  handleVendorGst = (e) => {
    let updateForm = { ...this.state.total };

    updateForm['vendorGstNo'] = e.target.value;
    this.setState({
      total: updateForm,
    });
  };
  handleDeliverDate = (e) => {
    //alert(e.target.value);
    let updateForm = { ...this.state.total };
    updateForm['deliverDate'] = e.target.value;
    this.setState({
      total: updateForm,
    });
  };
  handleInstallationDate = (e) => {
    let updateForm = { ...this.state.total };
    updateForm['installationDate'] = e.target.value;
    this.setState({
      total: updateForm,
    });
  };
  handleBillingDeliverAddress = (e) => {
    let updateForm = { ...this.state.total };
    updateForm['deliverAddress'] = e.target.value;
    this.setState({
      total: updateForm,
    });
  };
  handleDecathlonContactPerson = (e) => {
    let updateForm = { ...this.state.total };
    updateForm['decathlonContactPerson'] = e.target.value;
    this.setState({
      total: updateForm,
    });
  };
  handleDecathlonGst = (e) => {
    let updateForm = { ...this.state.total };
    updateForm['decathlonGst'] = e.target.value;
    this.setState({
      total: updateForm,
    });
  };
  curday = function (sp) {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + sp + mm + sp + yyyy;
  };
  componentDidMount() {
    let dummy = [];
    for (let i = 0; i < 3; i++) {
      let x = {
        id: i + 1,
        slno: i + 1,
        description: '',
        unit: '',
        qty: 0,
        rate: 0,
        amount: 0,
        gst: 0,
        gstAmount: 0,
        totalAmount: 0,
      };
      dummy.push(x);
    }
    this.setState({
      products: dummy,
    });
  }
  render() {
    let sumOfGrand = this.state.total.grandTotal;

    return (
      <div style={{ backgroundColor: '#eaf7fdcc' }}>
        <form
          style={{ backgroundColor: '#eaf7fdcc' }}
          className='needs-validation form-inline'
          onSubmit={(e) => {
            e.preventDefault();

            this.props.submitHandler(this.state);
          }}
          validate='true'
        >
          <div style={{ display: 'block' }}>
            <div className='row'>
              {/* <div className="col-md-6 md-form" style={{ marginTop: "5px" }}>
                <label for="validationCustom01" className="col-md-3">
                  PO No:
                </label>
                <input
                  type="text"
                  className="form-control col-md-3"
                  id="inputMDEx"
                  placeholder="PO No"
                  style={{ width: "75%" }}
                  value={this.state.total.poNo}
                  required
                />
                
              </div> */}
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  disabled
                  className='col-md-3'
                  id='Startdate'
                  label='PO Date:'
                  style={{ width: '75%' }}
                  defaultValue={this.curday('/')}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  disabled
                  className='col-md-3'
                  id='Startdate'
                  style={{ width: '75%' }}
                  label='Quotation Ref:'
                  value='YES'
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  disabled
                  className='col-md-3'
                  id='Startdate'
                  style={{ width: '75%' }}
                  label='Project Name:'
                  value={this.props.projectName}
                  required
                />
              </div>

              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  disabled
                  className='col-md-3'
                  id='Startdate'
                  style={{ width: '75%' }}
                  label='Quotation Date'
                  value={this.props.vendorInfo.quoteDate}
                  required
                />
              </div>

              <div
                className='col-md-6 '
                style={{ marginTop: '25px', marginBottom: '-30px' }}
              >
                <label
                  htmlFor='purchaseOrderDate'
                  style={{ float: 'left', fontWeight: '400' }}
                >
                  Delivery Date:
                </label>
                <input
                  type='date'
                  className='col-md-3 date-color'
                  id='purchaseOrderDate'
                  style={{
                    width: '75%',
                    marginTop: '40px',
                    marginLeft: '-90px',
                  }}
                  label='Delivery Date:'
                  data-date-format='dd/mm/yyyy'
                  min={dayjs().format('YYYY-MM-DD')}
                  value={this.state.total.deliverDate}
                  onChange={this.handleDeliverDate}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '25px' }}>
                <label
                  htmlFor='purchaseOrderDate'
                  style={{ float: 'left', fontWeight: '400' }}
                >
                  Installation Date:
                </label>
                <input
                  type='date'
                  className='col-md-3 date-color'
                  id='purchaseOrderDate'
                  style={{
                    width: '75%',
                    marginTop: '40px',
                    marginLeft: '-110px',
                  }}
                  label='Installation Date'
                  min={dayjs().format('YYYY-MM-DD')}
                  value={this.state.total.installationDate}
                  onChange={this.handleInstallationDate}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  multiline
                  type='text'
                  disabled
                  className='col-md-3'
                  id='Startdate'
                  style={{ width: '75%', marginTop: '20px' }}
                  label='To Address:'
                  value={this.props.vendorInfo.vendorAddress}
                  rows={5}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  multiline
                  type='text'
                  className='col-md-3 date-color'
                  id='Startdate'
                  style={{ width: '75%', marginTop: '20px' }}
                  label='Delivery and Billing Address:'
                  value={this.state.total.deliverAddress}
                  onChange={this.handleBillingDeliverAddress}
                  rows={5}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  className='col-md-3'
                  id='Startdate'
                  disabled
                  style={{ width: '75%' }}
                  label='Vendor Contact Person:'
                  value={this.props.vendorInfo.vendorContactPerson}
                  required
                />
              </div>

              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  className='col-md-3 date-color'
                  id='Startdate'
                  style={{ width: '75%' }}
                  label='Decathlon Contact Person:'
                  value={this.state.total.decathlonContactPerson}
                  onChange={this.handleDecathlonContactPerson}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  className='col-md-3'
                  id='Startdate'
                  disabled
                  style={{ width: '75%' }}
                  label='Vendor GST:'
                  value={
                    this.props.vendorInfo.vendorGst
                      ? this.props.vendorInfo.vendorGst
                      : this.state.total.vendorGstNo
                  }
                  onChange={this.handleVendorGst}
                  required
                />
              </div>
              <div className='col-md-6 ' style={{ marginTop: '5px' }}>
                <TextField
                  type='text'
                  className='col-md-3 date-color'
                  id='Startdate'
                  style={{ width: '75%' }}
                  label='Decathlon GST:'
                  value={this.state.total.decathlonGst}
                  onChange={this.handleDecathlonGst}
                  required
                />
              </div>
            </div>
            <label
              style={{
                float: 'left',
                marginLeft: '17px',
                marginTop: '50px',
                color: '#33aa33',
              }}
            >
              *Note: Use '+' icon to add new product's row.
            </label>

            <ProductTable
              onProductTableUpdate={this.handleProductTable.bind(this)}
              onRowAdd={this.handleAddEvent.bind(this)}
              onRowDel={this.handleRowDel.bind(this)}
              products={this.state.products}
              filterText={this.state.filterText}
            />

            <div className='col-md-12 ' style={{ marginTop: '15px' }}>
              <TextField
                type='number'
                className=' '
                id='Startdate'
                min='0'
                label='Freight Charges / Loading / Unloading :'
                step='0.01'
                value={this.state.total.freightCharge}
                onChange={this.handleFreightChange}
                required
                style={{ padding: '17px' }}
              />
            </div>
            {/* <div className="col-md-6 " style={{ marginTop: "5px" }}>
            <label for="validationCustom02">In Words:</label>
            <textarea
              type="text"
              className="form-control "
              id="validationCustom02"
              placeholder=""
              value={this.state.total.inWords}
               required 
            />
          </div>*/}
            <div className='col-md-12 ' style={{ marginTop: '5px' }}>
              <TextField
                multiline
                type='text'
                className=' '
                id='Startdate'
                style={{ width: '400px', lineHeight: '20px' }}
                label='Payment Terms:'
                rows={3}
                onChange={this.handleTermChange}
                value={this.state.total.terms}
                required
              />
            </div>
            <div className='col-md-4 ' style={{ marginTop: '15px' }}>
              <TextField
                type='text'
                className='col-md-3'
                id='Startdate'
                label='Sub Total:'
                value={this.state.total.subTotal}
                required
                style={{ padding: '10px', width: '150px', height: '200px' }}
              />
            </div>
            <div className='col-md-4 ' style={{ marginTop: '15px' }}>
              <TextField
                type='text'
                className='col-md-3'
                id='Startdate'
                label='GST Amount:'
                value={this.state.total.gstTotal}
                required
                style={{ padding: '10px', width: '150px', height: '200px' }}
              />
            </div>
            <div className='col-md-4 ' style={{ marginTop: '15px' }}>
              <TextField
                type='text'
                className='col-md-3'
                id='Startdate'
                label='Grand Total:'
                value={this.state.total.grandTotal}
                required
                style={{ padding: '10px', width: '150px', height: '200px' }}
              />
            </div>
          </div>
          <div style={{ display: 'block' }}>
            <button
              className='btn btn-secondary deca-btn-yellow a-update-email-alert'
              style={{ marginTop: '-80px', float: 'left' }}
              type='submit'
            >
              Generate PO
            </button>
          </div>
        </form>
      </div>
    );
  }
}
export default Products;
